import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BiyahekoLandingComponent } from './biyaheko-landing/biyaheko-landing.component';
import { LoginGuard } from '../core/guards/login-guard';
import { WhitelabelDetailsGuard } from '../core/guards/whitelabel-details.guard';

// Pre-login pages: the Biyaheko landing page and the BK Academy page. Login (/login)
// and register (/signup) are routed from app-routing.
const routes: Routes = [
    {
        path: '',
        // Signed-in agents skip the landing page and go straight to flight search.
        canActivate: [LoginGuard, WhitelabelDetailsGuard],
        // organisation sites (with an organization.code) and the BYK build go to /login instead
        data: { landingPage: true, bykLoginFirst: true },
        component: BiyahekoLandingComponent,
    },
    {
        // BK Academy packages page, linked from the landing page.
        path: 'academy',
        canActivate: [WhitelabelDetailsGuard],
        data: { landingPage: true },
        loadComponent: () => import('./biyaheko-academy/biyaheko-academy.component').then(m => m.BiyahekoAcademyComponent)
    },
    { path: 'account', canActivate: [WhitelabelDetailsGuard], loadChildren: () => import('../account/account.module').then(m => m.AccountModule) },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
})

export class HomePageModule { }
